module.exports = __webpack_public_path__ + "img/sofa.36285010.svg";